import { useEffect, useState, useMemo } from 'react';
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';

export function useLastSearches() {
  const [lastSearches, setLastSearches] = useState<string[]>([]);

  const recentSearchesPlugin = useMemo(
    () => createLocalStorageRecentSearchesPlugin({
      key: 'lastSearchesStorage',
      limit: 5,
    }),
    [],
  );

  async function refreshLastSearches() {
    try {
      if (recentSearchesPlugin.data) {
        const searches = recentSearchesPlugin.data.getAll();
        const items = await Promise.resolve(searches);

        if (Array.isArray(items) && items.length > 0) {
          const mapped = items.map((item: any) => item.label || item.id);
          setLastSearches(mapped);
        } else {
          setLastSearches([]);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao atualizar pesquisas recentes no localStorage:', error);
    }
  }

  function updateLastSearches(text: string) {
    if (text && recentSearchesPlugin.data) {
      try {
        recentSearchesPlugin.data.addItem({
          id: text,
          label: text,
        });

        refreshLastSearches();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Erro ao adicionar pesquisa recente no localStorage:', error);
      }
    }
  }

  function removeLastSearch(text: string) {
    try {
      if (recentSearchesPlugin.data) {
        recentSearchesPlugin.data.removeItem(text);
        refreshLastSearches();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao remover pesquisa recente no localStorage:', error);
    }
  }

  useEffect(() => {
    refreshLastSearches();
  }, []);

  return {
    lastSearches,
    updateLastSearches,
    removeLastSearch,
  };
}
